var CargoActions;
(function (CargoActions) {
    CargoActions["DELETE_CARGO"] = "DeleteCargo";
    CargoActions["DELETE_RANGE_CARGO"] = "DeleteRangeCargo";
    CargoActions["FILTER_CARGO"] = "FilterCargo";
    CargoActions["GET_CARGO"] = "GetCargo";
    CargoActions["GETWITHDISABLED_CARGO"] = "GetWithDisabledCargo";
    CargoActions["GET_BY_ID_CARGO"] = "GetByIdCargo";
    CargoActions["POST_CARGO"] = "PostCargo";
    CargoActions["PUT_CARGO"] = "PutCargo";
})(CargoActions || (CargoActions = {}));
var Fornecedor_ClienteActions;
(function (Fornecedor_ClienteActions) {
    Fornecedor_ClienteActions["DELETE_FORNECEDOR_CLIENTE"] = "DeleteFornecedor_Cliente";
    Fornecedor_ClienteActions["DELETE_RANGE_FORNECEDOR_CLIENTE"] = "DeleteRangeFornecedor_Cliente";
    Fornecedor_ClienteActions["FILTER_FORNECEDOR_CLIENTE"] = "FilterFornecedor_Cliente";
    Fornecedor_ClienteActions["GET_FORNECEDOR_CLIENTE"] = "GetFornecedor_Cliente";
    Fornecedor_ClienteActions["GETWITHDISABLED_FORNECEDOR_CLIENTE"] = "GetWithDisabledFornecedor_Cliente";
    Fornecedor_ClienteActions["GET_BY_ID_FORNECEDOR_CLIENTE"] = "GetByIdFornecedor_Cliente";
    Fornecedor_ClienteActions["POST_FORNECEDOR_CLIENTE"] = "PostFornecedor_Cliente";
    Fornecedor_ClienteActions["PUT_FORNECEDOR_CLIENTE"] = "PutFornecedor_Cliente";
    Fornecedor_ClienteActions["POSTBACK_FORNECEDOR_CLIENTE"] = "PostBackFornecedor_Cliente";
})(Fornecedor_ClienteActions || (Fornecedor_ClienteActions = {}));
var CNAE_FornecedorActions;
(function (CNAE_FornecedorActions) {
    CNAE_FornecedorActions["DELETE_CNAE_FORNECEDOR"] = "DeleteCNAE_Fornecedor";
    CNAE_FornecedorActions["DELETE_RANGE_CNAE_FORNECEDOR"] = "DeleteRangeCNAE_Fornecedor";
    CNAE_FornecedorActions["FILTER_CNAE_FORNECEDOR"] = "FilterCNAE_Fornecedor";
    CNAE_FornecedorActions["GET_CNAE_FORNECEDOR"] = "GetCNAE_Fornecedor";
    CNAE_FornecedorActions["GETWITHDISABLED_CNAE_FORNECEDOR"] = "GetWithDisabledCNAE_Fornecedor";
    CNAE_FornecedorActions["GET_BY_ID_CNAE_FORNECEDOR"] = "GetByIdCNAE_Fornecedor";
    CNAE_FornecedorActions["POST_CNAE_FORNECEDOR"] = "PostCNAE_Fornecedor";
    CNAE_FornecedorActions["PUT_CNAE_FORNECEDOR"] = "PutCNAE_Fornecedor";
    CNAE_FornecedorActions["POSTRANGE_CNAE_FORNECEDOR"] = "PostRangeCNAE_Fornecedor";
    CNAE_FornecedorActions["GET_BY_FORNECEDORID_CNAE_FORNECEDOR"] = "GetByFornecedorIdCNAE_Fornecedor";
})(CNAE_FornecedorActions || (CNAE_FornecedorActions = {}));
var Categoria_CustoActions;
(function (Categoria_CustoActions) {
    Categoria_CustoActions["DELETE_CATEGORIA_CUSTO"] = "DeleteCategoria_Custo";
    Categoria_CustoActions["DELETE_RANGE_CATEGORIA_CUSTO"] = "DeleteRangeCategoria_Custo";
    Categoria_CustoActions["FILTER_CATEGORIA_CUSTO"] = "FilterCategoria_Custo";
    Categoria_CustoActions["GET_CATEGORIA_CUSTO"] = "GetCategoria_Custo";
    Categoria_CustoActions["GETWITHDISABLED_CATEGORIA_CUSTO"] = "GetWithDisabledCategoria_Custo";
    Categoria_CustoActions["GET_BY_ID_CATEGORIA_CUSTO"] = "GetByIdCategoria_Custo";
    Categoria_CustoActions["POST_CATEGORIA_CUSTO"] = "PostCategoria_Custo";
    Categoria_CustoActions["PUT_CATEGORIA_CUSTO"] = "PutCategoria_Custo";
})(Categoria_CustoActions || (Categoria_CustoActions = {}));
var AdendosActions;
(function (AdendosActions) {
    AdendosActions["DELETE_ADENDOS"] = "DeleteAdendos";
    AdendosActions["DELETE_RANGE_ADENDOS"] = "DeleteRangeAdendos";
    AdendosActions["FILTER_ADENDOS"] = "FilterAdendos";
    AdendosActions["GET_ADENDOS"] = "GetAdendos";
    AdendosActions["GETWITHDISABLED_ADENDOS"] = "GetWithDisabledAdendos";
    AdendosActions["GET_BY_ID_ADENDOS"] = "GetByIdAdendos";
    AdendosActions["POST_ADENDOS"] = "PostAdendos";
    AdendosActions["PUT_ADENDOS"] = "PutAdendos";
})(AdendosActions || (AdendosActions = {}));
var ColaboradorActions;
(function (ColaboradorActions) {
    ColaboradorActions["DELETE_COLABORADOR"] = "DeleteColaborador";
    ColaboradorActions["DELETE_RANGE_COLABORADOR"] = "DeleteRangeColaborador";
    ColaboradorActions["FILTER_COLABORADOR"] = "FilterColaborador";
    ColaboradorActions["GET_COLABORADOR"] = "GetColaborador";
    ColaboradorActions["GETWITHDISABLED_COLABORADOR"] = "GetWithDisabledColaborador";
    ColaboradorActions["GET_BY_ID_COLABORADOR"] = "GetByIdColaborador";
    ColaboradorActions["POST_COLABORADOR"] = "PostColaborador";
    ColaboradorActions["PUT_COLABORADOR"] = "PutColaborador";
    ColaboradorActions["GETBYIDFORNECEDOR_COLABORADOR"] = "GetByIdFornecedorColaborador";
    ColaboradorActions["GETBYCOLABORADORPROJETO"] = "GetbyColaboradorProjeto";
})(ColaboradorActions || (ColaboradorActions = {}));
var Grau_InstrucaoActions;
(function (Grau_InstrucaoActions) {
    Grau_InstrucaoActions["DELETE_GRAU_INSTRUCAO"] = "DeleteGrau_Instrucao";
    Grau_InstrucaoActions["DELETE_RANGE_GRAU_INSTRUCAO"] = "DeleteRangeGrau_Instrucao";
    Grau_InstrucaoActions["FILTER_GRAU_INSTRUCAO"] = "FilterGrau_Instrucao";
    Grau_InstrucaoActions["GET_GRAU_INSTRUCAO"] = "GetGrau_Instrucao";
    Grau_InstrucaoActions["GETWITHDISABLED_GRAU_INSTRUCAO"] = "GetWithDisabledGrau_Instrucao";
    Grau_InstrucaoActions["GET_BY_ID_GRAU_INSTRUCAO"] = "GetByIdGrau_Instrucao";
    Grau_InstrucaoActions["POST_GRAU_INSTRUCAO"] = "PostGrau_Instrucao";
    Grau_InstrucaoActions["PUT_GRAU_INSTRUCAO"] = "PutGrau_Instrucao";
})(Grau_InstrucaoActions || (Grau_InstrucaoActions = {}));
var Orgao_EmissorActions;
(function (Orgao_EmissorActions) {
    Orgao_EmissorActions["DELETE_ORGAO_EMISSOR"] = "DeleteOrgao_Emissor";
    Orgao_EmissorActions["DELETE_RANGE_ORGAO_EMISSOR"] = "DeleteRangeOrgao_Emissor";
    Orgao_EmissorActions["FILTER_ORGAO_EMISSOR"] = "FilterOrgao_Emissor";
    Orgao_EmissorActions["GET_ORGAO_EMISSOR"] = "GetOrgao_Emissor";
    Orgao_EmissorActions["GETWITHDISABLED_ORGAO_EMISSOR"] = "GetWithDisabledOrgao_Emissor";
    Orgao_EmissorActions["GET_BY_ID_ORGAO_EMISSOR"] = "GetByIdOrgao_Emissor";
    Orgao_EmissorActions["POST_ORGAO_EMISSOR"] = "PostOrgao_Emissor";
    Orgao_EmissorActions["PUT_ORGAO_EMISSOR"] = "PutOrgao_Emissor";
})(Orgao_EmissorActions || (Orgao_EmissorActions = {}));
var Estado_CivilActions;
(function (Estado_CivilActions) {
    Estado_CivilActions["DELETE_ESTADO_CIVIL"] = "DeleteEstado_Civil";
    Estado_CivilActions["DELETE_RANGE_ESTADO_CIVIL"] = "DeleteRangeEstado_Civil";
    Estado_CivilActions["FILTER_ESTADO_CIVIL"] = "FilterEstado_Civil";
    Estado_CivilActions["GET_ESTADO_CIVIL"] = "GetEstado_Civil";
    Estado_CivilActions["GETWITHDISABLED_ESTADO_CIVIL"] = "GetWithDisabledEstado_Civil";
    Estado_CivilActions["GET_BY_ID_ESTADO_CIVIL"] = "GetByIdEstado_Civil";
    Estado_CivilActions["POST_ESTADO_CIVIL"] = "PostEstado_Civil";
    Estado_CivilActions["PUT_ESTADO_CIVIL"] = "PutEstado_Civil";
})(Estado_CivilActions || (Estado_CivilActions = {}));
var Grau_ExperienciaActions;
(function (Grau_ExperienciaActions) {
    Grau_ExperienciaActions["DELETE_GRAU_EXPERIENCIA"] = "DeleteGrau_Experiencia";
    Grau_ExperienciaActions["DELETE_RANGE_GRAU_EXPERIENCIA"] = "DeleteRangeGrau_Experiencia";
    Grau_ExperienciaActions["FILTER_GRAU_EXPERIENCIA"] = "FilterGrau_Experiencia";
    Grau_ExperienciaActions["GET_GRAU_EXPERIENCIA"] = "GetGrau_Experiencia";
    Grau_ExperienciaActions["GETWITHDISABLED_GRAU_EXPERIENCIA"] = "GetWithDisabledGrau_Experiencia";
    Grau_ExperienciaActions["GET_BY_ID_GRAU_EXPERIENCIA"] = "GetByIdGrau_Experiencia";
    Grau_ExperienciaActions["POST_GRAU_EXPERIENCIA"] = "PostGrau_Experiencia";
    Grau_ExperienciaActions["PUT_GRAU_EXPERIENCIA"] = "PutGrau_Experiencia";
})(Grau_ExperienciaActions || (Grau_ExperienciaActions = {}));
var Categoria_CNHActions;
(function (Categoria_CNHActions) {
    Categoria_CNHActions["DELETE_CATEGORIA_CNH"] = "DeleteCategoria_CNH";
    Categoria_CNHActions["DELETE_RANGE_CATEGORIA_CNH"] = "DeleteRangeCategoria_CNH";
    Categoria_CNHActions["FILTER_CATEGORIA_CNH"] = "FilterCategoria_CNH";
    Categoria_CNHActions["GET_CATEGORIA_CNH"] = "GetCategoria_CNH";
    Categoria_CNHActions["GETWITHDISABLED_CATEGORIA_CNH"] = "GetWithDisabledCategoria_CNH";
    Categoria_CNHActions["GET_BY_ID_CATEGORIA_CNH"] = "GetByIdCategoria_CNH";
    Categoria_CNHActions["POST_CATEGORIA_CNH"] = "PostCategoria_CNH";
    Categoria_CNHActions["PUT_CATEGORIA_CNH"] = "PutCategoria_CNH";
})(Categoria_CNHActions || (Categoria_CNHActions = {}));
var ContratosActions;
(function (ContratosActions) {
    ContratosActions["DELETE_CONTRATOS"] = "DeleteContratos";
    ContratosActions["DELETE_RANGE_CONTRATOS"] = "DeleteRangeContratos";
    ContratosActions["FILTER_CONTRATOS"] = "FilterContratos";
    ContratosActions["GET_CONTRATOS"] = "GetContratos";
    ContratosActions["GETWITHDISABLED_CONTRATOS"] = "GetWithDisabledContratos";
    ContratosActions["GET_BY_ID_CONTRATOS"] = "GetByIdContratos";
    ContratosActions["POST_CONTRATOS"] = "PostContratos";
    ContratosActions["PUT_CONTRATOS"] = "PutContratos";
})(ContratosActions || (ContratosActions = {}));
var CategoriaActions;
(function (CategoriaActions) {
    CategoriaActions["DELETE_CATEGORIA"] = "DeleteCategoria";
    CategoriaActions["DELETE_RANGE_CATEGORIA"] = "DeleteRangeCategoria";
    CategoriaActions["FILTER_CATEGORIA"] = "FilterCategoria";
    CategoriaActions["GET_CATEGORIA"] = "GetCategoria";
    CategoriaActions["GETWITHDISABLED_CATEGORIA"] = "GetWithDisabledCategoria";
    CategoriaActions["GET_BY_ID_CATEGORIA"] = "GetByIdCategoria";
    CategoriaActions["POST_CATEGORIA"] = "PostCategoria";
    CategoriaActions["PUT_CATEGORIA"] = "PutCategoria";
})(CategoriaActions || (CategoriaActions = {}));
var Adendo_ColaboradorActions;
(function (Adendo_ColaboradorActions) {
    Adendo_ColaboradorActions["DELETE_ADENDO_COLABORADOR"] = "DeleteAdendo_Colaborador";
    Adendo_ColaboradorActions["DELETE_RANGE_ADENDO_COLABORADOR"] = "DeleteRangeAdendo_Colaborador";
    Adendo_ColaboradorActions["FILTER_ADENDO_COLABORADOR"] = "FilterAdendo_Colaborador";
    Adendo_ColaboradorActions["GET_ADENDO_COLABORADOR"] = "GetAdendo_Colaborador";
    Adendo_ColaboradorActions["GET_ADENDO_COLABORADOR_POR_PROJETO"] = "GetAdendo_Colaborador_Por_Projeto";
    Adendo_ColaboradorActions["GETWITHDISABLED_ADENDO_COLABORADOR"] = "GetWithDisabledAdendo_Colaborador";
    Adendo_ColaboradorActions["GET_BY_ID_ADENDO_COLABORADOR"] = "GetByIdAdendo_Colaborador";
    Adendo_ColaboradorActions["POST_ADENDO_COLABORADOR"] = "PostAdendo_Colaborador";
    Adendo_ColaboradorActions["PUT_ADENDO_COLABORADOR"] = "PutAdendo_Colaborador";
    Adendo_ColaboradorActions["GET_BY_DATE_ADENDO_COLABORADOR"] = "GetByDateAdendoColaborador";
})(Adendo_ColaboradorActions || (Adendo_ColaboradorActions = {}));
var Projeto_ClienteActions;
(function (Projeto_ClienteActions) {
    Projeto_ClienteActions["DELETE_PROJETO_CLIENTE"] = "DeleteProjeto_Cliente";
    Projeto_ClienteActions["DELETE_RANGE_PROJETO_CLIENTE"] = "DeleteRangeProjeto_Cliente";
    Projeto_ClienteActions["FILTER_PROJETO_CLIENTE"] = "FilterProjeto_Cliente";
    Projeto_ClienteActions["GET_PROJETO_CLIENTE"] = "GetProjeto_Cliente";
    Projeto_ClienteActions["GETWITHDISABLED_PROJETO_CLIENTE"] = "GetWithDisabledProjeto_Cliente";
    Projeto_ClienteActions["GET_BY_ID_PROJETO_CLIENTE"] = "GetByIdProjeto_Cliente";
    Projeto_ClienteActions["POST_PROJETO_CLIENTE"] = "PostProjeto_Cliente";
    Projeto_ClienteActions["PUT_PROJETO_CLIENTE"] = "PutProjeto_Cliente";
})(Projeto_ClienteActions || (Projeto_ClienteActions = {}));
var Projeto_ColaboradorActions;
(function (Projeto_ColaboradorActions) {
    Projeto_ColaboradorActions["DELETE_PROJETO_COLABORADOR"] = "DeleteProjeto_Colaborador";
    Projeto_ColaboradorActions["DELETE_RANGE_PROJETO_COLABORADOR"] = "DeleteRangeProjeto_Colaborador";
    Projeto_ColaboradorActions["FILTER_PROJETO_COLABORADOR"] = "FilterProjeto_Colaborador";
    Projeto_ColaboradorActions["GET_PROJETO_COLABORADOR"] = "GetProjeto_Colaborador";
    Projeto_ColaboradorActions["GETWITHDISABLED_PROJETO_COLABORADOR"] = "GetWithDisabledProjeto_Colaborador";
    Projeto_ColaboradorActions["GET_BY_ID_PROJETO_COLABORADOR"] = "GetByIdProjeto_Colaborador";
    Projeto_ColaboradorActions["POST_PROJETO_COLABORADOR"] = "PostProjeto_Colaborador";
    Projeto_ColaboradorActions["PUT_PROJETO_COLABORADOR"] = "PutProjeto_Colaborador";
    Projeto_ColaboradorActions["GET_BY_ID_PROJETO_PROJETO_COLABORADOR"] = "GetByIdProjetoProjeto_Colaborador";
    Projeto_ColaboradorActions["GETPROJETOCOLABORADOR_PROJETO_COLABORADOR"] = "GetProjetoColaboradorProjeto_Colaborador";
    Projeto_ColaboradorActions["GETPROJETOCOLABORADOR_BY_COLABORADOR"] = "Getprojetocolaborador_By_Colaborador";
    Projeto_ColaboradorActions["GET_PROJETO_COLABORADOR_DIARIAS"] = "GetProjetoColaboradorDiarias";
})(Projeto_ColaboradorActions || (Projeto_ColaboradorActions = {}));
var Restritivos_ReembolsoActions;
(function (Restritivos_ReembolsoActions) {
    Restritivos_ReembolsoActions["DELETE_RESTRITIVOS_REEMBOLSO"] = "DeleteRestritivos_Reembolso";
    Restritivos_ReembolsoActions["DELETE_RANGE_RESTRITIVOS_REEMBOLSO"] = "DeleteRangeRestritivos_Reembolso";
    Restritivos_ReembolsoActions["FILTER_RESTRITIVOS_REEMBOLSO"] = "FilterRestritivos_Reembolso";
    Restritivos_ReembolsoActions["GET_RESTRITIVOS_REEMBOLSO"] = "GetRestritivos_Reembolso";
    Restritivos_ReembolsoActions["GETWITHDISABLED_RESTRITIVOS_REEMBOLSO"] = "GetWithDisabledRestritivos_Reembolso";
    Restritivos_ReembolsoActions["GET_BY_ID_RESTRITIVOS_REEMBOLSO"] = "GetByIdRestritivos_Reembolso";
    Restritivos_ReembolsoActions["POST_RESTRITIVOS_REEMBOLSO"] = "PostRestritivos_Reembolso";
    Restritivos_ReembolsoActions["PUT_RESTRITIVOS_REEMBOLSO"] = "PutRestritivos_Reembolso";
})(Restritivos_ReembolsoActions || (Restritivos_ReembolsoActions = {}));
var Categoria_ReembolsoActions;
(function (Categoria_ReembolsoActions) {
    Categoria_ReembolsoActions["DELETE_CATEGORIA_REEMBOLSO"] = "DeleteCategoria_Reembolso";
    Categoria_ReembolsoActions["DELETE_RANGE_CATEGORIA_REEMBOLSO"] = "DeleteRangeCategoria_Reembolso";
    Categoria_ReembolsoActions["FILTER_CATEGORIA_REEMBOLSO"] = "FilterCategoria_Reembolso";
    Categoria_ReembolsoActions["GET_CATEGORIA_REEMBOLSO"] = "GetCategoria_Reembolso";
    Categoria_ReembolsoActions["GETWITHDISABLED_CATEGORIA_REEMBOLSO"] = "GetWithDisabledCategoria_Reembolso";
    Categoria_ReembolsoActions["GET_BY_ID_CATEGORIA_REEMBOLSO"] = "GetByIdCategoria_Reembolso";
    Categoria_ReembolsoActions["POST_CATEGORIA_REEMBOLSO"] = "PostCategoria_Reembolso";
    Categoria_ReembolsoActions["PUT_CATEGORIA_REEMBOLSO"] = "PutCategoria_Reembolso";
})(Categoria_ReembolsoActions || (Categoria_ReembolsoActions = {}));
var Tipo_ReembolsoActions;
(function (Tipo_ReembolsoActions) {
    Tipo_ReembolsoActions["DELETE_TIPO_REEMBOLSO"] = "DeleteTipo_Reembolso";
    Tipo_ReembolsoActions["DELETE_RANGE_TIPO_REEMBOLSO"] = "DeleteRangeTipo_Reembolso";
    Tipo_ReembolsoActions["FILTER_TIPO_REEMBOLSO"] = "FilterTipo_Reembolso";
    Tipo_ReembolsoActions["GET_TIPO_REEMBOLSO"] = "GetTipo_Reembolso";
    Tipo_ReembolsoActions["GETWITHDISABLED_TIPO_REEMBOLSO"] = "GetWithDisabledTipo_Reembolso";
    Tipo_ReembolsoActions["GET_BY_ID_TIPO_REEMBOLSO"] = "GetByIdTipo_Reembolso";
    Tipo_ReembolsoActions["POST_TIPO_REEMBOLSO"] = "PostTipo_Reembolso";
    Tipo_ReembolsoActions["PUT_TIPO_REEMBOLSO"] = "PutTipo_Reembolso";
})(Tipo_ReembolsoActions || (Tipo_ReembolsoActions = {}));
var Material_ColaboradorActions;
(function (Material_ColaboradorActions) {
    Material_ColaboradorActions["DELETE_MATERIAL_COLABORADOR"] = "DeleteMaterial_Colaborador";
    Material_ColaboradorActions["DELETE_RANGE_MATERIAL_COLABORADOR"] = "DeleteRangeMaterial_Colaborador";
    Material_ColaboradorActions["FILTER_MATERIAL_COLABORADOR"] = "FilterMaterial_Colaborador";
    Material_ColaboradorActions["GET_MATERIAL_COLABORADOR"] = "GetMaterial_Colaborador";
    Material_ColaboradorActions["GETWITHDISABLED_MATERIAL_COLABORADOR"] = "GetWithDisabledMaterial_Colaborador";
    Material_ColaboradorActions["GET_BY_ID_MATERIAL_COLABORADOR"] = "GetByIdMaterial_Colaborador";
    Material_ColaboradorActions["POST_MATERIAL_COLABORADOR"] = "PostMaterial_Colaborador";
    Material_ColaboradorActions["PUT_MATERIAL_COLABORADOR"] = "PutMaterial_Colaborador";
    Material_ColaboradorActions["GET_BY_ID_COLABODADOR_MATERIAL_COLABORADOR"] = "GetByIdColaboradorMaterial_Colaborador";
})(Material_ColaboradorActions || (Material_ColaboradorActions = {}));
var Limites_ReembolsoActions;
(function (Limites_ReembolsoActions) {
    Limites_ReembolsoActions["DELETE_LIMITES_REEMBOLSO"] = "DeleteLimites_Reembolso";
    Limites_ReembolsoActions["DELETE_RANGE_LIMITES_REEMBOLSO"] = "DeleteRangeLimites_Reembolso";
    Limites_ReembolsoActions["FILTER_LIMITES_REEMBOLSO"] = "FilterLimites_Reembolso";
    Limites_ReembolsoActions["GET_LIMITES_REEMBOLSO"] = "GetLimites_Reembolso";
    Limites_ReembolsoActions["GETWITHDISABLED_LIMITES_REEMBOLSO"] = "GetWithDisabledLimites_Reembolso";
    Limites_ReembolsoActions["GET_BY_ID_LIMITES_REEMBOLSO"] = "GetByIdLimites_Reembolso";
    Limites_ReembolsoActions["POST_LIMITES_REEMBOLSO"] = "PostLimites_Reembolso";
    Limites_ReembolsoActions["PUT_LIMITES_REEMBOLSO"] = "PutLimites_Reembolso";
})(Limites_ReembolsoActions || (Limites_ReembolsoActions = {}));
var TimesheetActions;
(function (TimesheetActions) {
    TimesheetActions["DELETE_TIMESHEET"] = "DeleteTimesheet";
    TimesheetActions["DELETE_RANGE_TIMESHEET"] = "DeleteRangeTimesheet";
    TimesheetActions["FILTER_TIMESHEET"] = "FilterTimesheet";
    TimesheetActions["GET_TIMESHEET"] = "GetTimesheet";
    TimesheetActions["GETWITHDISABLED_TIMESHEET"] = "GetWithDisabledTimesheet";
    TimesheetActions["GET_BY_ID_TIMESHEET"] = "GetByIdTimesheet";
    TimesheetActions["POST_TIMESHEET"] = "PostTimesheet";
    TimesheetActions["POSTBACK_TIMESHEET"] = "PostBackTimesheet";
    TimesheetActions["PUT_TIMESHEET"] = "PutTimesheet";
    TimesheetActions["GET_TIMESHEET_GRID"] = "GetTimesheetGrid";
    TimesheetActions["SUBMETER_TIMESHEET"] = "SubmeterTimesheet";
    TimesheetActions["SUBMETER_TIMESHEET_LOTE"] = "SubmeterTimesheetLote";
    TimesheetActions["GET_TIMESHEET_STATUS"] = "GetTimesheetStatus";
})(TimesheetActions || (TimesheetActions = {}));
var ReembolsoActions;
(function (ReembolsoActions) {
    ReembolsoActions["DELETE_REEMBOLSO"] = "DeleteReembolso";
    ReembolsoActions["DELETE_RANGE_REEMBOLSO"] = "DeleteRangeReembolso";
    ReembolsoActions["FILTER_REEMBOLSO"] = "FilterReembolso";
    ReembolsoActions["GET_REEMBOLSO"] = "GetReembolso";
    ReembolsoActions["GETWITHDISABLED_REEMBOLSO"] = "GetWithDisabledReembolso";
    ReembolsoActions["GET_BY_ID_REEMBOLSO"] = "GetByIdReembolso";
    ReembolsoActions["POST_REEMBOLSO"] = "PostReembolso";
    ReembolsoActions["PUT_REEMBOLSO"] = "PutReembolso";
    ReembolsoActions["UPLOAD_IMAGE"] = "UploadImage";
    ReembolsoActions["GET_ACEITE_REEMBOLSO"] = "GetAceiteReembolso";
    ReembolsoActions["PUT_STATUS_REEMBOLSO"] = "PutStatusReembolso";
    ReembolsoActions["PUT_STATUS_REEMBOLSO_LOTE"] = "PutStatusReembolsoLote";
    ReembolsoActions["GET_REEMBOLSO_TOTALIZER"] = "GetReembolsoTotalizer";
    ReembolsoActions["PUT_EDITARREEMBOLSO"] = "Put_EditarReembolso";
})(ReembolsoActions || (ReembolsoActions = {}));
var Status_ReembolsoActions;
(function (Status_ReembolsoActions) {
    Status_ReembolsoActions["DELETE_STATUS_REEMBOLSO"] = "DeleteStatus_Reembolso";
    Status_ReembolsoActions["DELETE_RANGE_STATUS_REEMBOLSO"] = "DeleteRangeStatus_Reembolso";
    Status_ReembolsoActions["FILTER_STATUS_REEMBOLSO"] = "FilterStatus_Reembolso";
    Status_ReembolsoActions["GET_STATUS_REEMBOLSO"] = "GetStatus_Reembolso";
    Status_ReembolsoActions["GETWITHDISABLED_STATUS_REEMBOLSO"] = "GetWithDisabledStatus_Reembolso";
    Status_ReembolsoActions["GET_BY_ID_STATUS_REEMBOLSO"] = "GetByIdStatus_Reembolso";
    Status_ReembolsoActions["POST_STATUS_REEMBOLSO"] = "PostStatus_Reembolso";
    Status_ReembolsoActions["PUT_STATUS_REEMBOLSO"] = "PutStatus_Reembolso";
})(Status_ReembolsoActions || (Status_ReembolsoActions = {}));
var DiariaActions;
(function (DiariaActions) {
    DiariaActions["DELETE_DIARIA"] = "DeleteDiaria";
    DiariaActions["DELETE_RANGE_DIARIA"] = "DeleteRangeDiaria";
    DiariaActions["FILTER_DIARIA"] = "FilterDiaria";
    DiariaActions["GET_DIARIA"] = "GetDiaria";
    DiariaActions["GETWITHDISABLED_DIARIA"] = "GetWithDisabledDiaria";
    DiariaActions["GET_BY_ID_DIARIA"] = "GetByIdDiaria";
    DiariaActions["POST_DIARIA"] = "PostDiaria";
    DiariaActions["POSTBACK_DIARIA"] = "PostBackDiaria";
    DiariaActions["PUT_DIARIA"] = "PutDiaria";
    DiariaActions["GET_DIARIA_GRID"] = "GetDiariaGrid";
    DiariaActions["SUBMETER_DIARIA"] = "SubmeterDiaria";
    DiariaActions["SUBMETER_DIARIA_LOTE"] = "SubmeterDiariaLote";
})(DiariaActions || (DiariaActions = {}));
var Status_DiariaActions;
(function (Status_DiariaActions) {
    Status_DiariaActions["DELETE_STATUS_DIARIA"] = "DeleteStatus_Diaria";
    Status_DiariaActions["DELETE_RANGE_STATUS_DIARIA"] = "DeleteRangeStatus_Diaria";
    Status_DiariaActions["FILTER_STATUS_DIARIA"] = "FilterStatus_Diaria";
    Status_DiariaActions["GET_STATUS_DIARIA"] = "GetStatus_Diaria";
    Status_DiariaActions["GETWITHDISABLED_STATUS_DIARIA"] = "GetWithDisabledStatus_Diaria";
    Status_DiariaActions["GET_BY_ID_STATUS_DIARIA"] = "GetByIdStatus_Diaria";
    Status_DiariaActions["POST_STATUS_DIARIA"] = "PostStatus_Diaria";
    Status_DiariaActions["PUT_STATUS_DIARIA"] = "PutStatus_Diaria";
})(Status_DiariaActions || (Status_DiariaActions = {}));
var Horas_AdicionaisActions;
(function (Horas_AdicionaisActions) {
    Horas_AdicionaisActions["DELETE_HORAS_ADICIONAIS"] = "DeleteHoras_Adicionais";
    Horas_AdicionaisActions["DELETE_RANGE_HORAS_ADICIONAIS"] = "DeleteRangeHoras_Adicionais";
    Horas_AdicionaisActions["FILTER_HORAS_ADICIONAIS"] = "FilterHoras_Adicionais";
    Horas_AdicionaisActions["GET_HORAS_ADICIONAIS"] = "GetHoras_Adicionais";
    Horas_AdicionaisActions["GETWITHDISABLED_HORAS_ADICIONAIS"] = "GetWithDisabledHoras_Adicionais";
    Horas_AdicionaisActions["GET_BY_ID_HORAS_ADICIONAIS"] = "GetByIdHoras_Adicionais";
    Horas_AdicionaisActions["POST_HORAS_ADICIONAIS"] = "PostHoras_Adicionais";
    Horas_AdicionaisActions["POST_MULTIPLE_DATES_HORAS_ADICIONAIS"] = "Post_MultipleDatesHoras_Adicionais";
    Horas_AdicionaisActions["PUT_HORAS_ADICIONAIS"] = "PutHoras_Adicionais";
})(Horas_AdicionaisActions || (Horas_AdicionaisActions = {}));
export { Fornecedor_ClienteActions, ColaboradorActions, Grau_InstrucaoActions, Orgao_EmissorActions, Estado_CivilActions, CargoActions, Grau_ExperienciaActions, Categoria_CNHActions, CNAE_FornecedorActions, Categoria_CustoActions, ContratosActions, CategoriaActions, Adendo_ColaboradorActions, AdendosActions, Projeto_ClienteActions, Projeto_ColaboradorActions, Restritivos_ReembolsoActions, Categoria_ReembolsoActions, Tipo_ReembolsoActions, Material_ColaboradorActions, Limites_ReembolsoActions, TimesheetActions, ReembolsoActions, Status_ReembolsoActions, DiariaActions, Status_DiariaActions, Horas_AdicionaisActions, };
//# sourceMappingURL=FornecEnums.js.map